import { createAction } from 'redux-actions'
import R from 'ramda'

import * as WebAPI from '../api'
import { getPlaceById } from '../reducers/places'
import { getMediaItemById } from '../reducers/mediaItems'

export const loadJobs = createAction('FETCH_JOBS', WebAPI.fetchJobs, (companyId, params) => params)
export const loadCompany = createAction('FETCH_COMPANY', WebAPI.fetchCompany)
export const loadPlaces = createAction('FETCH_PLACES', WebAPI.fetchPlaces)
export const loadAssociatedCategories = createAction('FETCH_ASSOCIATED_CATEGORIES', WebAPI.fetchAccosiatedCategories)
export const loadCompanyLogo = createAction('FETCH_COMPANY_LOGO', WebAPI.fetchCompanyLogo)

export const loadPlacesIfNeeded = placesIds => (dispatch, getState) => {
  const placeExist = id => getPlaceById(getState(), id)
  const fetchPlaces = ids => dispatch(loadPlaces(ids))
  const emptyResult = () => Promise.resolve(null)

  return R.compose(
    R.ifElse(
      R.isEmpty,
      emptyResult,
      fetchPlaces
    ),
    R.reject(placeExist)
  )(placesIds)
}

export const loadCompanyLogoIfNeeded = id => async (dispatch, getState) => {
  const item = getMediaItemById(getState(), id)
  if (id && !item) {
    return dispatch(loadCompanyLogo(id)).then(res => res.value).catch(() => {})
  }
  return item
}

export const loadAssociatedCategoriesIfNeeded = companyId => (dispatch, getState) => {
  const items = getState().categories || []
  if (items.length === 0) {
    return dispatch(loadAssociatedCategories(companyId)).then(({ value }) => value)
  }
  return items
}



// WEBPACK FOOTER //
// ./src/actions/index.js